module.exports = "@media (min-width: 1340px) {\n  .mapContainer {\n    max-width: 400px; } }\n\nagm-map {\n  height: 340px; }\n\n.small-text {\n  font-size: 0.8rem;\n  font-weight: 500;\n  line-height: 0.9rem;\n  color: #9B9B9B; }\n\n.band-info-box {\n  max-width: 383px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/beacon-zone/beacon-zone.component.scss
// module id = ./src/app/shared/components/beacon-zone/beacon-zone.component.scss
// module chunks = main